import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Jumbotron } from 'reactstrap';

import Footer from '../../Components/Footer';
import FormConsultaPermissaoAtividade from './FormConsultaPermissaoAtividade';
import FormConsultaInformacaoBasica from './FormConsultaInformacaoBasica';

import { Aside, Content, Item, Section } from './styles';
import { setState } from '~/store/modules/documentsEmission/actions';

const Service = () => {
	const dispatch = useDispatch();
	const { presselected } = useSelector((e) => e.documentsEmission);

	const [selectedOption, setSelectedOption] = useState('');

	useEffect(() => {
		if (presselected) {
			setSelectedOption(presselected);
			dispatch(setState(null));
		}
	}, [dispatch, presselected]);

	return (
		<>
			<Content>
				<Aside>
					<h3>Documentos</h3>
					<Item
						selected={
							selectedOption === 'consulta-informacao-basica'
						}
						onClick={() =>
							setSelectedOption('consulta-informacao-basica')
						}
					>
						Consulta de Informação Básica
					</Item>
					<Item
						selected={
							selectedOption === 'consulta-permissao-de-atividade'
						}
						onClick={() =>
							setSelectedOption('consulta-permissao-de-atividade')
						}
					>
						Consulta de Permissão de Atividade
					</Item>
				</Aside>
				{selectedOption === '' && (
					<Section>
						<Jumbotron style={{ background: 'transparent' }}>
							<h1 className="display-6">Emissão de Documentos</h1>
							<p className="lead">
								Selecione o serviço desejado no menu lateral.
							</p>
							<hr className="my-2" />
						</Jumbotron>
					</Section>
				)}
				{selectedOption === 'consulta-informacao-basica' && (
					<FormConsultaInformacaoBasica />
				)}
				{selectedOption === 'consulta-permissao-de-atividade' && (
					<FormConsultaPermissaoAtividade />
				)}
			</Content>
			<Footer />
		</>
	);
};

export default Service;
